import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectUserPermissions } from '../modules/auth.js';
import { isAuthorized } from './AuthorizedAction.js';
import { EmployeeLink } from './links/index.jsx';

// Owner name linked to the employee profile. EmployeeLink renders nothing
// without frontend "read employee", so the plain name is the fallback.
const OwnerName = connect((state) => ({
  permissions: selectUserPermissions(state),
}))(({ owner, name, permissions }) =>
  isAuthorized('read', 'employee', permissions) ? (
    <EmployeeLink
      employeeId={owner.id}
      className={owner.archived ? 'text-muted' : undefined}
    >
      {owner[name]}
    </EmployeeLink>
  ) : (
    owner[name]
  )
);

// showAll: render every owner (one per line) instead of "2 owners + N"
// linkToEmployee: owner names link to the employee profile (owners must be
// employees with an id, not users)
const OwnersList = ({
  owners,
  nameKey,
  row = false,
  showAll = false,
  linkToEmployee = false,
}) => {
  const [showOwners, setShowOwners] = useState(showAll);

  const name = nameKey || 'name';

  const renderOwner = (owner, key) => (
    <div
      key={key}
      className={`flex m-r-12 ${owner.archived ? 'text-muted' : ''}`}
    >
      {owner.avatar ? (
        <div
          className={`flex profile-avatar small m-r-10 ${owner.archived ? 'text-muted' : ''}`}
        >
          <img src={owner.avatar} alt="avatar" />
        </div>
      ) : null}
      {linkToEmployee ? <OwnerName owner={owner} name={name} /> : owner[name]}
    </div>
  );

  return !showOwners ? (
    <strong
      className={`flex ${row ? 'flex-wrap' : 'flex-col'} flex-align-start owners-list`}
    >
      {renderOwner(owners[0], 0)}
      {owners[1] ? renderOwner(owners[1], 1) : null}
      {owners.length > 2 ? (
        <button
          type="button"
          className={`btn-link btn-clear bg-transparent p-0 ${row ? 'm-t-2' : 'm-0'}`}
          onClick={() => setShowOwners(true)}
        >
          +{owners.length - 2}
        </button>
      ) : null}
    </strong>
  ) : (
    <strong
      className={`flex ${row ? 'flex-wrap' : 'flex-col'} flex-align-start owners-list`}
    >
      {owners.map((owner, index) => renderOwner(owner, index))}
    </strong>
  );
};

export default OwnersList;
